import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AnaliseService } from '../../../../providers/analise-service';

@Component({
    selector: 'page-modal-pv-contabilidade',
    templateUrl: 'modal-pv-contabilidade.html'
})
export class ModalPreVisualizarContabilidadePage {
    titulo: any;
    isJurisdicionado: any;
    listaDados: any;
    listaDadosBaixa: any = [];
    listaDadosReincidencia: any = [];
    listaDadosOutros: any = [];
    dataGeracao: any;
    loading: boolean = true;
    shownGroup: any = [];
    abaTipoBalanco: any;

    constructor(private viewCtrl: ViewController,
        public navParams: NavParams,
        public analiseService: AnaliseService,
        public alertCtrl: AlertController,
        public gestaoPcaService: GestaoPcaService) {

        this.dataGeracao = new Date();

        this.abaTipoBalanco = 'ingressos';

        this.listarDados();
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    listarDados() {
        this.analiseService.obterPreviewCertificado().subscribe(
            data => {
                this.listaDados = data;

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            }
        );
    }

    //  #region Métodos do Accordion
    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            let index = this.shownGroup.indexOf(group);
            this.shownGroup.splice(index, 1);
        } else {
            this.shownGroup.push(group);
        }
    }

    isGroupShown(group) {
        return this.shownGroup.indexOf(group) != -1;
    }

    formatarValorNumerico(valor) {
        if (!valor) {
            valor = 0;
        }
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    indicaComparacao(analise) {
        let diff: any = "";

        if(!analise.saldoS2GPR){
            diff = "Saldo Declarado X Saldo do Extrato";
        } else if(!analise.saldoExtrato){
            diff = "Saldo Declarado X Saldo do SIAFE";
        } else if(!analise.saldoConta){
            diff = "Saldo do SIAFE X Saldo do Extrato";
        }

        return diff;
    }

    calcularDiferenca(analise) {
        let diff: any = 0;

        if(!analise.saldoS2GPR){
            diff = analise.saldoConta - analise.saldoExtrato;
        } else if(!analise.saldoExtrato){
            diff = analise.saldoConta - analise.saldoS2GPR;
        } else if(!analise.saldoConta){
            diff = analise.saldoS2GPR - analise.saldoExtrato;
        }

        return diff;
    }

    formatarPorcentagem(valor) {
        if (!valor) {
            valor = 0;
        }
        return valor.toString().replace('.', ',') + "%";
    }

    getAnalisesByTipoIndice(tipoIndice: string) {
        return [this.listaDados.indicadores.analises.find(a => a.tipoIndice === tipoIndice)];
    }

    getAnalisesByTipoIndiceEGE(tipoIndice: string) {
        return [this.listaDados.indicadoresEGE.analises.find(a => a.tipoIndice === tipoIndice)];
    }

    isVoid(text){
        return text === '';
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/contabilidade/modal-pv-contabilidade.ts